const naturalCollator = new Intl.Collator("de", {
  numeric: true,
  sensitivity: "base",
  ignorePunctuation: false,
});

export function naturalCompare(left: unknown, right: unknown) {
  return naturalCollator.compare(String(left ?? ""), String(right ?? ""));
}

export function dateCompare(left: string | null | undefined, right: string | null | undefined) {
  return String(left ?? "").localeCompare(String(right ?? ""));
}
